import { useCallback, useEffect, useState } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { GetClinicReportAction } from '@/application/actions';
import type { ClinicReportDTO } from '@/domain/repositories/IReportRepository';

export const useClinicReport = () => {
  const [report, setReport] = useState<ClinicReportDTO | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<GetClinicReportAction>(TYPES.GetClinicReportAction);
      setReport(await action.execute());
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to load clinic report'));
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { report, isLoading, error, refetch: load };
};
